import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "@messages/en.json";
import de from "@messages/de.json";

export const SUPPORTED_LOCALES = ["en", "de"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: Locale = "en";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de },
    },
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES as unknown as string[],
    // next-intl catalogs use single-brace {var} interpolation; consume them
    // verbatim so the EN/DE files stay byte-identical and shared with Next
    // (no codemod, no second copy). i18next defaults to {{var}}.
    interpolation: { prefix: "{", suffix: "}", escapeValue: false },
    // Locale lives in the URL path (/en/..., /de/...) — read it from segment 0.
    detection: { order: ["path", "navigator"], lookupFromPathIndex: 0 },
    react: { useSuspense: false },
  });

export default i18n;
